import React, { Component } from 'react'
import './index.css'

export default class SpoofWarning extends Component {
  currentEventUser() {
    const {
      users,
      currentUser } = this.props
    if (users && currentUser) {
      return users.event_users.find((user) => {
        return user.user_id === currentUser.user_id
      })
    }
  }

  render() {
    const {
      credentials } = this.props
    const currentEventUser = this.currentEventUser()
    let message = ''
    if (currentEventUser) {
      let name = `${ currentEventUser.first_name } ${ currentEventUser.last_name }`
      message = `You are currently logged in as ${ name }.`
    } else if (credentials && credentials.email) {
      message = `You are currently logged in as ${ credentials.email }.`
    } else if (credentials) {
      message = 'You are currently logged in as another user.'
    }

    if (credentials && credentials.isSpoofing) {
      return (
        <div className="spoof-warning">
          { message }
        </div>
      )
    } else {
      return <div></div>
    }
  }
}

